
// return name if slug is matched from array of slugs
function transformCategory(slug, categories) {
    const category = categories.find((category) => category.node.slug === slug);
    return category ? category.node.name : slug;
}

const getSocialText = (str) => {
    try {
        return str.split("|")[0];
    }
    catch (err) {
        console.log("getSocialText failed: ", err);
    }
}

export { transformCategory, getSocialText };